import * as actionType from 'actions';
import secureStorage from 'utils/secureStorage';

const initialState = {
    errorMessage: {},
    errorStatus: false,
    stateListForCountries: {},
    countyListArr: [],
    isLoading: false,
    isCountryLoading: false,
    jobCountry: {},
    isUpdatePasswordModifiedDetailLoading: false,
    updatePasswordModifiedDetail: {},
    isUserPasswordModifiedDetailLoading: false,
    userPasswordModifiedDetail: {},
    isSendMailOnLogoutSuccess: false,
    isApplicantJobInviteExistsLoading: false,
    applicantJobInviteExists: {},
};

const common = (state = initialState, action) => {
    switch (action.type) {
        case actionType.GET_COUNTRY: {
            return {
                ...state,
                isCountryLoading: true,
            };
        }

        case actionType.GET_COUNTRY_SUCCESS: {
            const jobCountryCode = secureStorage.getItem('jobUrlCountryCode');
            
            return {
                ...state,
                isCountryLoading: false,
                countries: action.payload.countryList,
                jobCountry: action.payload.countryList.find(country => country.id == jobCountryCode) ?? {}
            };
        }

        case actionType.GET_STATE: {
            return {
                ...state,
                isLoading: true,
            };
        }

        case actionType.GET_STATE_SUCCESS: {
            return {
                ...state,
                isLoading: false,
                stateListForCountries: state?.stateListForCountries?.hasOwnProperty(action?.payload?.countryCode) 
                ? { ...state?.stateListForCountries }
                : { 
                    [action?.payload?.countryCode]: action?.payload?.stateList,
                    ...state?.stateListForCountries 
                }
            };
        }

        case actionType.GET_COUNTY: {
            return {
                ...state,
                isLoading: true,
            };
        }

        case actionType.GET_COUNTY_SUCCESS: {
            return {
                ...state,
                isLoading: false,
                countyListArr: [...state.countyListArr, action.payload]
            };
        }

        case actionType.SEND_MAIL_ON_LOGOUT: {
            return {
                ...state,
            };
        }

        case actionType.SEND_MAIL_ON_LOGOUT_SUCCESS: {
            return {
                ...state,
                isSendMailOnLogoutSuccess: true,
            };
        }

        case actionType.UPDATE_USER_PASSWORD_MODIFIED_DETAIL_POST: {
            return {
                ...state,
                isUpdatePasswordModifiedDetailLoading: true,
                updatePasswordModifiedDetail: {},
            };
        }

        case actionType.UPDATE_USER_PASSWORD_MODIFIED_DETAIL_SUCCESS: {
            return {
                ...state,
                isUpdatePasswordModifiedDetailLoading: false,
                updatePasswordModifiedDetail: action?.payload,
            };
        }

        case actionType.GET_USER_PASSWORD_MODIFIED_DETAIL_POST: {
            return {
                ...state,
                isUserPasswordModifiedDetailLoading: true,
                userPasswordModifiedDetail: {}
            };
        }

        case actionType.GET_USER_PASSWORD_MODIFIED_DETAIL_SUCCESS: {
            return {
                ...state,
                isUserPasswordModifiedDetailLoading: false,
                userPasswordModifiedDetail: action.payload,
            };
        }

        case actionType.GET_APPLICANT_JOB_INVITE_EXISTS_POST: {
            return {
                ...state,
                isApplicantJobInviteExistsLoading: true,
                applicantJobInviteExists: {}
            };
        }

        case actionType.GET_APPLICANT_JOB_INVITE_EXISTS_SUCCESS: {
            return {
                ...state,
                isApplicantJobInviteExistsLoading: false,
                applicantJobInviteExists: action.payload,
            };
        }

        case actionType.COMMON_ERROR: {
            return {
                ...state,
                errorMessage: action.payload.error,
                isUpdatePasswordModifiedDetailLoading: false,
                isUserPasswordModifiedDetailLoading: false,
                errorStatus: true,
                isLoading: false,
                isCountryLoading: false,
                isSendMailOnLogoutSuccess: false,
                isApplicantJobInviteExistsLoading: false,
            }
        }

        case actionType.COMMON_ERROR_CLOSE: {
            return {
                ...state,
                errorStatus: false
            }
        }

        default: {
            return state;
        }
    }
};

export default common;